import { useLocation, useParams } from 'react-router-dom';
import { Prompt } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPostsRoot, getPostsFeedType } from 'redux/selectors';
import useFetchPost from '../Lifebooks/utils/useFetchPost';
import { AddImages, InfoTag, PageLayout } from 'components';
import * as PostComp from './components';
import { getRequestedPostFeedType } from './utils/servicePostUtils';
import styles from './editPost.module.css';

const EditPost = ({ fetchNspCount, routeRoot }) => {
	const { postId } = useParams();
	const { search } = useLocation();
	const root = useSelector(getPostsRoot);
	const isVault = root === 'vault';
	const feedType = useSelector(getPostsFeedType);
	const isCaseManager = useSelector(
		(state) => state.user.user.type === 'case-manager'
	);

	const { state, setState, handlers } = useFetchPost();
	const { handleChange } = handlers;
	const { photoLoading, nspDescription, relations } = state;
	const isServiceIntent =
		feedType === 'services' ||
		getRequestedPostFeedType(search) === 'services';

	return (
		<PageLayout
			showChildContext={isCaseManager}
			header={<PostComp.EditPostHeader postId={postId} />}
			footer={
				<PostComp.EditPostButtonContainer
					{...{ postState: state, fetchNspCount, root, routeRoot }}
				/>
			}>
			<Prompt
				message={(location) => {
					if (window?.location?.pathname?.includes('/vault')) {
						if (!state.id) {
							if (
								state.category !== '' ||
								state.title !== '' ||
								state.body !== '' ||
								state.photos?.length > 0 ||
								state.videos?.length > 0
							) {
								if (
									location.pathname.includes('/pending') ||
									location.pathname.includes('/vault')
								) {
									return true;
								} else {
									return `Any information added will be lost do you wish to continue?`;
								}
							}
						}
					}
					return;
				}}
			/>
			<div className={styles.editPostContainer}>
				<div className={styles.addPostContent}>
					{!isVault && (
						<>
							<PostComp.ChangeRequestEdit {...state} />
							<PostComp.EditPostServiceSelector
								state={state}
								setState={setState}
							/>
						</>
					)}
					{Boolean(nspDescription) ? <InfoTag>{nspDescription}</InfoTag> : null}
					<AddImages
						setState={setState}
						deletePhoto={handlers.deletePhoto}
						loading={photoLoading}
						photos={state.photos}
						videos={state.videos}
						allowVideo
					/>
					<form className={styles.addPostForm}>
						{!isVault && !postId && !isServiceIntent && (
							<PostComp.SuggestedPost handleChange={handleChange} />
						)}
						<PostComp.EditPostBasicInfo handlers={handlers} post={state} />
						{!postId && ['lifebooks'].includes(root) && (
							<PostComp.TagSibling
								relations={relations}
								setRelations={(relations) => {
									setState({ relations });
								}}
							/>
						)}
						{!isVault && !isCaseManager && (
							<PostComp.EditPostNote
								{...{ ...state, handleChange: handlers.handleChange }}
							/>
						)}
					</form>
				</div>
			</div>
		</PageLayout>
	);
};

export default EditPost;
